<template>
    <div>
        <v-dialog v-model="productListDialog" content-class="product-list-con" :overlay-opacity="opacity">
            <div class="productlist-con">
                <!-- header part  -->
                <div class="flex header">
                    <div class="flex">
                        <v-icon @click="handleBackBtn" class="icon" color="#1F8F58" size="25"> mdi-arrow-left </v-icon>
                        <h3 class="header-text">Product selection</h3>
                    </div>
                    <h3 class="header-text">2/2</h3>
                </div>

                <!-- loader section  -->
                <div v-if="loading" class="loader">
                    <v-progress-circular :size="100" :width="8" color="#6FB793" indeterminate></v-progress-circular>
                </div>
                <div class="nodata-msg" v-else-if="!loading && totalProductCount === 0">
                    <p>No data present.</p>
                </div>

                <div v-else @scroll="onScroll" class="productcard-con flex">
                    <div v-for="(item, i) in productList" :key="i">
                        <div class="product-card flex" @click="selectedProduct = item.id" :class="{active: item.id === selectedProduct}">
                            <img :src="item.images.length !== 0 && item.images[0].image ? item.images[0].image.original : defaultImage" alt="" />
                            <h3>{{ item.product_name }}</h3>
                        </div>
                    </div>
                </div>

                <!-- button section  -->
                <div class="button-section flex">
                    <v-btn @click="handleCancelBtn" elevation="0" class="cancel-btn" color="#EBF5F0"> Cancel </v-btn>
                    <v-btn @click="handleNextBtn" elevation="0" class="next-btn" color="#1D8D56" :disabled="selectedProduct === ''"> Next </v-btn>
                </div>
            </div>
        </v-dialog>
        <div v-if="createAdOverlay">
        <create-advertisement
            :cardSize="cardSize"
            :data="dataforApi"
            :product="this.productId"
            :createAdOverlay="createAdOverlay"
            @closeCreateAdOverlay="closeCreateAdOverlay"
            @cancelAdCreation="handleCancelBtn"
            @closeAll="reloadApi"
        />
        </div>
    </div>
</template>

<script>
import createAdvertisement from "./create-advertisement.vue";
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
export default {
    name: "productList",
    data() {
        return {
            productListDialog: this.productListOverlay,
            opacity: 0,
            createAdOverlay: false,
            productList: [],
            selectedProduct: "",
            allQactive: true,
            dataforApi: this.data,
            defaultImage: require("../../../../assets/MainDashboard/Products/DefaultImage.png"),
            pageno: 1,
            totalProductCount: 0,
            loading: true,
            productId : {},
        };
    },
    props: {
        productListOverlay: Boolean,
        data: Object,
        selectedCompanyID: String,
        cardSize: Array,
    },
    components: {
        "create-advertisement": createAdvertisement,
    },
    watch: {
        productListOverlay: function () {
            this.productListDialog = this.productListOverlay;
            console.log("selectedCompanyID-->", this.selectedCompanyID);
        },

    },
    mounted() {
        this.getProducts();
        console.log("selectedCompanyID-->", this.selectedCompanyID);
    },
    methods: {
        closeCreateAdOverlay() {
            this.createAdOverlay = false;
        },
        handleBackBtn() {
            this.$emit("closeProductListOverlay");
        },
        handleCancelBtn() {
            this.createAdOverlay = false;
            this.$emit("closeAll");
        },
        reloadApi() {
            if (this.createAdOverlay) this.createAdOverlay = false;
            this.$emit("reloadApi");
        },
        handleNextBtn() {
            this.productId.id = this.selectedProduct;
            this.dataforApi.product = this.selectedProduct;
            this.createAdOverlay = true;
        },

        onScroll({target: {scrollTop, clientHeight, scrollHeight}}) {
            if (scrollTop + clientHeight + 1 >= scrollHeight) {
                if (this.pageno * 10 <= this.totalProductCount) {
                    this.pageno = this.pageno + 1;
                    this.getProducts();
                }
            }
        },

        getProducts() {
            this.loading = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.loading = false;
                    console.log("RESPONSE-->", response.data.data);
                    // this.productList = response.data.data;
                    this.totalProductCount = response.data.total_count;
                    response.data.data.map((item) => {
                        this.productList.push(item);
                    });
                }
            };
            const errorHandler = (response) => {
                this.loading = false;

                this.showToast("Something went wrong internally!", "error", 10000);
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": this.selectedCompanyID,
                // "business-id" : this.selectedCompanyID,
            };
            this.requestGETwithoutHeader(`${API_URL.products__list}?page=${this.pageno}&data_per_page=${10}`, {}, headers, successHandler, errorHandler);
        },
    },
};
</script>

<style lang="scss" scoped>
.productlist-con {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 25px;
    min-height: 500px;
}
img {
    height: 59px;
    width: 70px;
}
.header {
    justify-content: space-between;
    margin-bottom: 25px;
}
.header-text {
    font-weight: 500;
    font-size: 1.2rem;
    color: #333333;
    margin-left: 15px;
}
.icon {
    background-color: #eff6f3;
    padding: 8px;
    border-radius: 6px;
}
.productcard-con {
    width: 100%;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;
    // height: 170px;
    height: 450px;
    overflow-y: scroll;
    overflow-x: hidden;
    align-content: start;
}

// css for individual product card
.product-card {
    cursor: pointer;
    width: 360px;
    // width: 49%;
    border: 0.5px solid #cfcfcf;
    border-radius: 6px;
    min-height: 80px;
    justify-content: flex-start;
    padding: 10px 20px;

    h3 {
        color: #445149;
        font-weight: 500;
        font-size: 18px;
        margin-left: 16px;
    }
    &.active {
        h3 {
            color: #1d8d56;
            font-weight: 600;
        }
        border: 1px solid #1d8d56;
    }
}

// button section
.button-section {
    justify-content: space-between;
    margin-top: 30px;
    .v-btn {
        width: 48%;
        height: 56px !important;
        text-transform: capitalize !important;
        font-size: 1.1rem;
    }
}
.cancel-btn {
    color: #1d8d56 !important;
    font-size: 1rem;
}
.next-btn {
    color: #ffffff;
    font-size: 1rem;
}
.v-input {
    padding-bottom: 20px;
}

// scrollbar design
::-webkit-scrollbar {
    width: 9px;
    // border-left: 1px solid rgba(50, 52, 65, 0.1);
    // border-right: 1px solid rgba(50, 52, 65, 0.1);
    margin-left: 100px;
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(50, 52, 65, 0.4);
    border: 2px solid transparent;
    background-clip: content-box;
}
::-webkit-scrollbar-track {
    display: none;
}
::-webkit-scrollbar-corner {
    display: none;
    height: 0px;
    width: 0px;
}
.nodata-msg {
    width: 100%;
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60vh;
}
</style>
<style>
.product-list-con.v-dialog {
    width: 800px;
    background-color: white;
    border-radius: 10px;
    box-shadow: none;
    height: 650px;
}
</style>